import Http from "@/commons/Http";

const path = 'api/checklist-protocol-person';

export default {

    async save(protocolId, certificates){
        return Http.post(`${path}/${protocolId}`, certificates);
    },

    async saveOne(certificate){
        return Http.post(`${path}/save-one`, certificate);
    },

    async delete(checklistProtocolPerson) {
        return Http.delete(`${path}/${checklistProtocolPerson}`);
    },

    async getById(id){
        return Http.get(`${path}/${id}`);
    },

    async getPersonsMissingInChecklist(id){
        return Http.get(`${path}/protocol/clients-protocol-checklist/${id}`);
    },

    async getByProtocolId(id){
        return Http.get(`${path}/protocol/${id}`);
    },
}
